import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusLandingEditor from 'components/editor/movies/landing/landingFocus';
import UniversalLandingEditor from 'components/editor/movies/landing/landingUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusLandingEditor {...props} />;
	return <UniversalLandingEditor {...props} />;
};